import { ProductCenterRouteMap } from '@/new-router/product-center'

const Home = () => import('@/views/Home/home')

const CopyrightDeposit = () => import('@/views/Copyright/index')

/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export default [
  {
    path: '/copyright',
    name: 'copyright',
    component: Home,
    meta: {
      title: '版权存证',
      icon: 'icon-configuration',
      showSubiems: false,
      sort: 3,
      modules: 'copyright',
      permission: 'user:thirdBlockList',
    },
    children: [
      {
        path: 'copyright-main',
        name: 'copyright-main',
        component: CopyrightDeposit,
        meta: {
          title: '版权存证',
          active: ['copyright-main'],
          permission: 'user:thirdBlockList',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.IpCopyright],
        },
      },
    ],
  },
]
